import React from 'react';
import panelDataSec from '../config/panelsLED.json';

function LedDisplayoptions({ selectedWall, product, pixelPitch, ledModel, productOptions, modualOptions, pixelpitchOptions, setWall, setProduct, setLedModel, setPixelPitch}) { 

    return (
        <div className="col custom-border-color p-4 mt-3">
            <h4>LED Display Options</h4><hr/>
                <div id="text-primary">Wall Setup</div>
                <select className="form-control form-control-lg mt-3" name="select-wall" value={selectedWall} onChange={(e) => setWall(e.target.value)}>
                    {(Object.keys(panelDataSec)||[]).map(p => <option key={p} value={p}>{p}</option>)}
                </select>
                <div className="mt-3" id="text-primary">Choose DVLED Product</div>
                <select className="form-control form-control-lg mt-3" name="select-product" value={product} onChange={(e) => setProduct(e.target.value)}>
                    {(Object.keys(productOptions)||[]).map(p => <option key={p} value={p}>{p}</option>)}
                </select>

                <div className="mt-3" id="text-primary">Modual Type<span className="star-mark"> (Required)</span></div>
                <select className="form-control form-control-lg mt-3" name="select-modual" value={ledModel} onChange={(e) => {setLedModel(e.target.value);}}>
                    {(Object.keys(modualOptions)||[]).map(p => <option key={p} value={p}>{p}</option>)}
                </select>

                <div className="mt-3" id="text-primary">Pixel Pitch<span className="star-mark"> (Required)</span></div>
                <select className="form-control form-control-lg mt-3" name="select-pixel-pitch" value={pixelPitch} onChange={(e) => {setPixelPitch(e.target.value);}}>
                    <option value="-">-</option>
                    {(Object.keys(pixelpitchOptions)||[]).map(p => <option key={p} value={p}>{p}</option>)}
                </select>
        </div>
    );
}

export default LedDisplayoptions;
